module.exports = __webpack_public_path__ + "static/media/threeDots.4f474b38.svg";